export default __webpack_public_path__ + "static/media/logo_dark.5df527a2.png";